// src/config.js

const envApiUrl = process.env.REACT_APP_API_URL?.replace(/\/+$/, '');
const isBrowser = typeof window !== 'undefined';
const hostname = isBrowser ? window.location.hostname : '';

let baseURL = envApiUrl;

if (!baseURL) {
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    baseURL = `http://${hostname}:5555`;
  } else if (isBrowser) {
    // Default to same-origin in production so Cloud Run custom domains work
    // without rebuilding the frontend for each backend hostname.
    baseURL = window.location.origin;
  } else {
    baseURL = 'http://localhost:5555';
  }
}

const API_URL = baseURL.replace(/\/+$/, '');

export default API_URL;
